import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { TutorService } from 'src/app/service/tutor.service';
import { StorageService } from 'src/app/service/storage.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { apiService } from 'src/app/service/api.service';

@Component({
  selector: 'app-inicio-mega-tutor',
  templateUrl: './inicio-mega-tutor.component.html',
  styleUrls: ['./inicio-mega-tutor.component.css']
})
export class InicioMegaTutorComponent implements OnInit {

  @ViewChild('divSpinner') divSpinner:ElementRef;
  megaTutorData: any;
  tutoresData: any;
  idUsuario : any;
  cargando = true;
  tutorCounter = 0;
  collapsing = true;

  constructor(
    private storageService: StorageService,
    private tutorService: TutorService,
    private spinner: NgxSpinnerService,
    private api: apiService
    ) 
    { }

    getMegaTutor(id) {
      this.tutorService.API_POST_getTutorObjectByIdUsuario(id).subscribe((response:any) => {
        this.megaTutorData = response.payload;
        this.tutorService.API_POST_obtenerTutoresMegatutor(this.megaTutorData.idPersonaPeriodo).subscribe((response:any) => {
          this.tutoresData = response.payload;
          if(response.payload != ""){
            for (const tutorData of this.tutoresData) {
              this.tutorCounter++;
              this.api.API_POST_obtenerFotoPerfil(tutorData.idUsuario).subscribe((response:any) => {
                const urlPerfil = response.payload;
                if (urlPerfil != null) {
                  tutorData["urlPicture"] = "data:image/jpg;base64,"+urlPerfil;
                } else {
                  tutorData["urlPicture"] = "../../../assets/JUNJI_avatar.svg";
                }
                this.cargando = false;
              },
              (err) => { 
                console.log(err)
              })
            }
          }else{this.cargando = false;}


        },
        (err) => { 
          console.log(err)
        })
      },
      (err) => { 
        console.log(err)
      })
  }

  ngOnInit() : void {
    this.cargaInicial();
  }

  cargaInicial(){
    this.cargando = true;
    this.spinner.show();
    this.idUsuario = this.storageService.getCurrentUser().idUsuario;
    this.getMegaTutor(this.idUsuario);
    this.spinner.hide();
  }

  
  capitalize(string){
    return string[0].toUpperCase() + string.slice(1);
  }

}
